import { createFileRoute } from '@tanstack/react-router';
import { CampaignDetailPage } from '@/pages/member-portal/campaigns/CampaignDetailPage';

// Campaign detail (viewer) — resolved by `slug`.
function MemberPortalCampaignDetailRoute() {
	return <CampaignDetailPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/campaigns/$slug')({
	component: MemberPortalCampaignDetailRoute,
});
